import React from 'react';

const Row = ({ k, v }) => (v ? <div className="flex gap-3 py-1"><span className="w-36 shrink-0 text-slate-500">{k}</span><span className="text-slate-800 whitespace-pre-wrap break-words min-w-0">{v}</span></div> : null);
const fmt = (d) => (d ? new Date(d).toLocaleString() : '');

export const BetaApplicationView = ({ t }) => {
  const a = t.application || {};
  const r = t.betaProgram.reminders || {};
  return (
    <div className="text-sm space-y-4" data-testid={`beta-application-${t.practiceId}`}>
      <div>
        <h4 className="font-semibold text-slate-900 mb-1">Application</h4>
        <Row k="Name" v={a.fullName} /><Row k="Email" v={t.email} /><Row k="Phone" v={a.phone} /><Row k="Website" v={a.website} />
        <Row k="Specialty" v={a.specialty} /><Row k="Town" v={a.cityState} /><Row k="Comms today" v={a.currentComms} /><Row k="Why pick them" v={a.whyPick} />
        <Row k="Video testimonial" v={a.videoOk ? 'Yes, willing' : 'No'} /><Row k="Public review" v={a.publicReviewOk ? 'Yes, plans to' : 'Not promised'} />
      </div>
      <div>
        <h4 className="font-semibold text-slate-900 mb-1">Beta timeline</h4>
        <Row k="Joined" v={fmt(t.betaProgram.joinedAt)} /><Row k="Ends" v={t.status === 'lifetime' ? 'Never — free for life' : fmt(t.endsAt)} />
        <Row k="Extended" v={t.betaProgram.extendedDays ? `+${t.betaProgram.extendedDays} days` : ''} />
        <Row k="Reminders sent" v={[r.d14 && `14-day: ${fmt(r.d14)}`, r.d7 && `7-day: ${fmt(r.d7)}`, r.end && `Ended: ${fmt(r.end)}`,
          t.betaProgram.lastManualReminderAt && `Manual: ${fmt(t.betaProgram.lastManualReminderAt)}`].filter(Boolean).join('\n') || 'None yet'} />
        <Row k="Lifetime granted" v={fmt(t.betaProgram.lifetimeGrantedAt)} /><Row k="Removed" v={fmt(t.betaProgram.removedAt)} />
      </div>
      <details className="bg-slate-50 border border-slate-200 rounded-lg p-3">
        <summary className="cursor-pointer font-semibold text-slate-900" data-testid={`beta-signed-terms-${t.practiceId}`}>Signed agreement ({a.termsVersion})</summary>
        <ol className="mt-2 space-y-1.5 list-decimal pl-5 text-slate-700">{(a.termsShown || []).map((x, i) => <li key={i}>{x}</li>)}</ol>
        <p className="mt-3 text-slate-700">
          Ticked: agree to all {a.agreeAll ? '✔' : '✘'} · photo guarantee {a.photoGuarantee ? '✔' : '✘'} · publish permission {a.publishPermission ? '✔' : '✘'}
        </p>
        <p className="mt-1 text-slate-700">Signed as <em className="font-semibold">{a.signature}</em> on {fmt(a.signedAt)} from {a.ipAddress || 'unknown IP'}</p>
      </details>
    </div>
  );
};
